import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customPhone'
})
export class PhoneWithExtPipe implements PipeTransform {
  transform(phoneNumber) {
    if (!phoneNumber) return 'N/A';
    let area = '(' + phoneNumber.slice(0, 3) + ') ';
    let first = phoneNumber.slice(3, 6) + '-';
    let second = phoneNumber.slice(6, 10);
    let hyphenIndex = phoneNumber.indexOf('x');
    let ext = hyphenIndex ? phoneNumber.slice(hyphenIndex, phoneNumber.length).replace(/x+/g, '') : '';
    return area + first + second + (ext ? ( ' x ' + ext) : '');
  }
}